<!-- eslint-disable quotes -->
<!-- eslint-disable quotes -->
<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="800px">
      <v-card>
        <v-toolbar elevation="0" color="background">
          <v-toolbar-title
            class="pl-4 text-h6 font-weight-medium"
            :class="{
              'brand--text text--darken-2': !$vuetify.theme.dark,
            }"
            >E-Book</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text
          justify="center"
          class="pl-8 py-2 pr-0 quillScroll"
          style="height: 400px; overflow-y: auto; width: 96%"
        >
          <quill-editor
            v-model="content"
            ref="myQuillEditor"
            :options="editorOptions"
          >
          </quill-editor>
        </v-card-text>
        <v-col cols="12" class="pa-0">
          <v-divider />
        </v-col>
        <v-card-actions class="pl-8 pr-8 py-6">
          <BaseBtn
            type="secondary"
            class="elevation-0 mr-4 px-4"
            :disabled="checkIfHasChanged"
            @click="handleDiscardChanges"
          >
            {{ $t('message.pages.video.discardChanges') }}
          </BaseBtn>
          <v-spacer></v-spacer>
          <BaseBtn
            :loading="loadings.updatingEbook"
            class="elevation-0 primary white--text"
            type="primary"
            @click="updateEbook"
          >
            {{ $t('message.pages.video.save') }}
          </BaseBtn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import aiworkflowApi from '@/services/aiworkflowApi'
import _ from 'lodash'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import BaseBtn from '@/components/BaseBtn.vue'

export default {
  name: 'VideoPlayerEbookModal',
  components: { quillEditor, BaseBtn },
  data: () => ({
    open: false,
    isEditing: false,
    content: '',
    initialContentVal: '',
    loadings: {
      updatingEbook: false,
    },
    editorOptions: {
      debug: 'info',
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'], // toggled buttons
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          // [{ align: ['justify', 'center', 'right'] }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link'],
        ],
      },
      scrollingContainer: 'quillScroll',
    },
  }),
  mounted() {
    this.$root.$on('openVideoEbookModal', (data) => {
      this.open = true
      this.setAbstract(data.ebook)
    })
  },
  computed: {
    checkIfHasChanged() {
      return _.isEqual(this.content, this.initialContentVal)
    },
  },
  watch: {},
  beforeDestroy() {},
  methods: {
    setAbstract(abstract) {
      let val = _.cloneDeep(abstract)
      this.content = this.convertToQuillHTML(val)
      this.initialContentVal = _.cloneDeep(this.content)
    },
    convertToQuillHTML(markdownText) {
      const lines = markdownText.split('\n')
      let quillText = ''

      for (const line of lines) {
        if (line.startsWith('#')) {
          const level = line.lastIndexOf('#') + 1
          quillText += `<h${level}>${line.slice(level).trim()}</h${level}>\n\n`
        } else if (line.startsWith('##')) {
          quillText += `<h2>${line.slice(2).trim()}</h2>\n\n`
        } else if (line.startsWith('###')) {
          quillText += `<h3>${line.slice(3).trim()}</h3>\n\n`
        } else if (line.startsWith('####')) {
          quillText += `<h4>${line.slice(4).trim()}</h4>\n\n`
        } else if (line.startsWith('#####')) {
          quillText += `<h5>${line.slice(5).trim()}</h5>\n\n`
        } else if (line.startsWith('######')) {
          quillText += `<h6>${line.slice(6).trim()}</h6>\n\n`
        } else if (line.startsWith('-')) {
          quillText += `<ul><li>${line.slice(1).trim()}</li></ul>\n\n`
        } else if (line.trim() !== '') {
          quillText += `<p>${this.handleInlineStyles(line)}</p>\n\n`
        }
      }

      return quillText.trim()
    },

    handleInlineStyles(line) {
      line = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      line = line.replace(/__(.*?)__/g, '<u>$1</u>')
      line = line.replace(/\*(.*?)\*/g, '<em>$1</em>')
      // Add support for other inline styles here if needed
      return line
    },
    convertToMarkdown(quillHTML) {
      const parser = new DOMParser()
      const doc = parser.parseFromString(quillHTML, 'text/html')
      let markdown = ''

      function convertChildren(node) {
        let text = ''
        node.childNodes.forEach((childNode) => {
          if (childNode.nodeType === Node.TEXT_NODE) {
            text += childNode.textContent
          } else if (childNode.nodeType === Node.ELEMENT_NODE) {
            switch (childNode.tagName.toLowerCase()) {
              case 'strong':
                text += `**${convertChildren(childNode)}**`
                break
              case 'em':
                text += `*${convertChildren(childNode)}*`
                break
              case 'u':
                text += `<u>${convertChildren(childNode)}</u>`
                break
              default:
                text += convertChildren(childNode)
            }
          }
        })
        return text
      }

      Array.from(doc.body.children).forEach((element) => {
        switch (element.tagName.toLowerCase()) {
          case 'h1':
          case 'h2':
          case 'h3':
          case 'h4':
          case 'h5':
          case 'h6':
            markdown += `${'#'.repeat(
              parseInt(element.tagName.charAt(1))
            )} ${convertChildren(element).trim()}\n\n`
            break
          case 'p':
            markdown += `${convertChildren(element).trim()}\n\n`
            break
          case 'ul':
            Array.from(element.children).forEach((li) => {
              markdown += `- ${convertChildren(li).trim()}\n`
            })
            markdown += '\n'
            break
          case 'ol':
            Array.from(element.children).forEach((li, index) => {
              markdown += `${index + 1}. ${convertChildren(li).trim()}\n`
            })
            markdown += '\n'
            break
          case 'blockquote':
            markdown += `> ${convertChildren(element).trim()}\n\n`
            break
        }
      })

      return markdown.trim()
    },
    handleDiscardChanges() {
      this.content = _.cloneDeep(this.initialContentVal)
      this.initialContentVal = _.cloneDeep(this.content)
    },
    async updateEbook() {
      this.loadings.updatingEbook = true
      const videoId = this.$route.params.id
      const newTextValue = this.convertToMarkdown(this.content)
      const aiData = {
        video_id: videoId,
        abstract: newTextValue,
      }
      try {
        let res = await aiworkflowApi.updateAiWorkFlowData(aiData)
        this.setAbstract(res.data.abstract)
        this.$root.$emit('updateEbookData', res.data.abstract)
        this.loadings.updatingEbook = false
        this.handleClose()
      } catch (e) {
        this.loadings.updatingEbook = false
        console.error('e', e)
      }
    },
    handleClose() {
      this.open = null
    },
  },
}
</script>

<style scoped>
.cardTitle {
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
}
.scroll-container {
  max-height: 400px;
  overflow-y: auto;
}
</style>
